export default "__VITE_PUBLIC_ASSET__98332ab4__"